@if (stocks?.length) {
  <table class="table table-striped table-hover mb-3">
    <thead>
      <tr>
        <th scope="col" class="text-center">Year</th>
        <th scope="col" class="text-right">Share $</th>
        <th scope="col" class="text-right">Share Note</th>
        <th scope="col" class="text-right">Div. $</th>
        <th scope="col" class="text-right">Div. Note</th>
      </tr>
    </thead>
    <tbody>
      @for (stock of stocks; track stock.id) {
        <tr>

          <td class="text-center">
            <span class="text-underline text-site-primary-alt pointable"
                  (click)="showStock(stock)"
                  title="View {{stock.year}} Stock Year">
              {{stock.year}}
            </span>
          </td>
          <td class="text-right">{{stock.statedShareValue|currency}}</td>
          <td class="text-right">{{stock.statedValueNote}}</td>
          <td class="text-right">{{stock.dividendPerShare|currency}}</td>
          <td class="text-right">{{stock.dividendNote}}</td>
        </tr>
      }
    </tbody>
  </table>
}


@if (!currentYearStockPricing) {
  <div class="row">

    <div class="col text-center">

      <button class="btn btn-site-primary" (click)="showStock()" type="button">
        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> Add New Stock Pricing
      </button>

    </div>

  </div>
}
